import { config } from "@/config/app";

/**
 * Mensagens de validação de telefone. Ficam fora do i18n do React porque
 * também são usadas em módulos puros (lib/phoneUtils), fora de componentes.
 */
export type PhoneMessageKey =
  | "required"
  | "keepTyping"
  | "invalid"
  | "invalidFormat"
  | "mobileRequired"
  | "validationError"
  | "valid"
  | "brDigits"
  | "brFormat"
  | "brDdd"
  | "brFirstDigit";

type PhoneMessages = Record<PhoneMessageKey, string>;

const MESSAGES: Record<"pt-BR" | "pt-PT" | "en-US", PhoneMessages> = {
  "pt-BR": {
    required: "Número de telefone é obrigatório",
    keepTyping: "Continue digitando o número",
    invalid: "Número de telefone inválido",
    invalidFormat: "Formato de número inválido",
    mobileRequired: "O WhatsApp requer um número de celular",
    validationError: "Erro ao validar número de telefone",
    valid: "Número válido para WhatsApp",
    brDigits: "O número deve ter 11 dígitos (DDD + celular)",
    brFormat: "Use o formato (11) 91234-5678",
    brDdd: "DDD inválido. Use um DDD entre 11 e 99",
    brFirstDigit: "O celular deve começar com 9",
  },
  "pt-PT": {
    required: "O número de telefone é obrigatório",
    keepTyping: "Continua a escrever o número",
    invalid: "Número de telefone inválido",
    invalidFormat: "Formato de número inválido",
    mobileRequired: "O WhatsApp exige um número de telemóvel",
    validationError: "Erro ao validar o número de telefone",
    valid: "Número válido para WhatsApp",
    // Regras específicas do Brasil, exibidas se a utilizadora escolher 🇧🇷 no seletor.
    brDigits: "O número deve ter 11 dígitos (DDD + telemóvel)",
    brFormat: "Usa o formato (11) 91234-5678",
    brDdd: "DDD inválido. Usa um DDD entre 11 e 99",
    brFirstDigit: "O telemóvel deve começar por 9",
  },
  "en-US": {
    required: "Phone number is required",
    keepTyping: "Keep typing the number",
    invalid: "Invalid phone number",
    invalidFormat: "Invalid number format",
    mobileRequired: "WhatsApp requires a mobile number",
    validationError: "Error validating phone number",
    valid: "Valid WhatsApp number",
    brDigits: "The number must have 11 digits (area code + mobile)",
    brFormat: "Use the format (11) 91234-5678",
    brDdd: "Invalid area code. Use a value between 11 and 99",
    brFirstDigit: "The mobile number must start with 9",
  },
};

export function phoneMessage(key: PhoneMessageKey): string {
  const language = config.i18n.language;
  const messages =
    MESSAGES[language as keyof typeof MESSAGES] ?? MESSAGES["pt-BR"];
  return messages[key];
}
